import { api } from './client'

export type VehicleType = 'motorbike' | 'van' | 'truck' | 'car' | 'other'
export type VehicleStatus = 'available' | 'in_use' | 'maintenance' | 'retired'
export type GpsProvider = 'vnetgps' | null

export interface Vehicle {
    id: string
    plate_number: string
    name: string
    type: VehicleType
    capacity_kg?: number | null
    seat_count?: number | null
    status: VehicleStatus
    note?: string | null
    gps_provider?: GpsProvider
    gps_imei?: string | null
    gps_device_id?: string | null
    created_at: string
    updated_at: string
}

export interface ListVehiclesParams {
    page?: number
    per_page?: number
    status?: VehicleStatus
    search?: string
}

export interface CreateVehicleRequest {
    plate_number: string
    name: string
    type: VehicleType
    capacity_kg?: number | null
    seat_count?: number | null
    note?: string | null
    gps_provider?: GpsProvider
    gps_imei?: string | null
}

export type UpdateVehicleRequest = CreateVehicleRequest

export const vehicleApi = {
    list: (params?: ListVehiclesParams) =>
        api.get<Vehicle[]>('/vehicles', { params }),
    available: () => api.get<Vehicle[]>('/vehicles/available'),
    getById: (id: string) => api.get<Vehicle>(`/vehicles/${id}`),
    create: (data: CreateVehicleRequest) =>
        api.post<Vehicle>('/vehicles', data),
    update: (id: string, data: UpdateVehicleRequest) =>
        api.put<Vehicle>(`/vehicles/${id}`, data),
    delete: (id: string) => api.delete(`/vehicles/${id}`),
    setStatus: (id: string, status: VehicleStatus) =>
        api.patch<Vehicle>(`/vehicles/${id}/status`, { status }),
}
